import React from "react";
import { ClipboardList } from "lucide-react";
import { StatusPill } from "src/components/ui";
import type { PORegion, SubPOStatus } from "src/types/database/subPurchaseOrder";

interface SubPurchaseOrderHeadingSectionProps {
  subPurchaseOrderId: string;
  status: SubPOStatus;
  region?: PORegion;
  vendorName?: string;
}

const SubPurchaseOrderHeadingSection: React.FC<SubPurchaseOrderHeadingSectionProps> = ({
  subPurchaseOrderId,
  status,
  region,
  vendorName
}) => {
  return (
    <section className="overflow-hidden rounded-2xl border border-secondary-200 shadow-soft bg-white">
      <div className="bg-gradient-to-r from-secondary-900 via-secondary-800 to-secondary-700 px-8 py-6 sm:px-10 sm:py-8">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-start gap-4">
            <div className="rounded-xl bg-white/10 p-3 text-white">
              <ClipboardList className="h-7 w-7" />
            </div>
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.25em] text-secondary-200">Sub Purchase Order</p>
              <h1 className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">{subPurchaseOrderId}</h1>
              <p className="mt-3 text-sm text-secondary-100">
                {vendorName || region ? (
                  <>
                    {region && <span>{region}</span>}
                    {region && vendorName && <span className="text-secondary-300"> · </span>}
                    {vendorName}
                  </>
                ) : (
                  "Regional split linked to the main purchase order — line items and warehouse detail below."
                )}
              </p>
            </div>
          </div>

          <div className="flex flex-col items-end gap-3">
            <StatusPill status={status} />
          </div>
        </div>
      </div>
    </section>
  );
};

export { SubPurchaseOrderHeadingSection };
